import $ from 'cash-dom'

const updateCartTierMessage = (data) => {
  const message = $('[data-element="tier-exceeded-message"]')
  const id = '14693567365485'
  const items = data.items.filter(item => item.product_id.toString() === id)
  const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0)

  if (totalQuantity > 8) {
    message.removeClass('hidden')
  } else {
    message.addClass('hidden')
  }
}

export { updateCartTierMessage }
